  document.addEventListener('DOMContentLoaded', function() {
    // Hide testimonials if client has closed them (cookie exists)
    var seenPT = getCookieJS("closePT");
    if (seenPT !== "") {
      var style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = '#pTestimonials { display:none !important}';
      document.head.appendChild(style);
      console.log("Hide PT");
    }

    // Handle closing testimonials
    document.querySelector('#pTestimonials .prClose')?.addEventListener('click', function() {
      setCookieJS("closePT", true, 1); // Set cookie to stop testimonials showing for 1 day
    });

    // Handle checkbox for notes
    var chkNotes = document.getElementById('chkNotes');
    if (chkNotes) {
      chkNotes.addEventListener('change', function() {
        var updateCart = document.getElementById('update-cart');
        if (chkNotes.checked) {
          updateCart.classList.add('notes-open');
        } else {
          updateCart.classList.remove('notes-open');
        }
      });
    }

    // Handle keyup for font preview
    var fontPreviewText = document.getElementById('font-preview-text');
    if (fontPreviewText) {
      fontPreviewText.addEventListener('keyup', updateFontPreview);
    }

    // Initialize FAQs click events
    initFAQs();
  });

  // Update font preview text
  function updateFontPreview() {
    var val = document.getElementById('font-preview-text').value;
    document.querySelectorAll('.preview-text').forEach(function(preview) {
      preview.textContent = val;
    });
  }

  // Initialize FAQ section
  function initFAQs() {
    document.querySelectorAll(".faqs h3").forEach(function(header) {
      header.addEventListener("click", function() {
        var content = header.nextElementSibling;
        if (content && content.classList.contains("faqContent")) {
          content.style.display = content.style.display === 'none' ? 'block' : 'none';
        }
      });
    });
  }

  // ── Arlo cart property enhancer ─────────────────────────────────────────────
  // Scans the entire document for ucarecdn.com URLs in text nodes and replaces
  // them with thumbnail images. Works with any cart app (Unicorn, theme, etc.)
  (function arloCartPreviews() {
    var UCARECDN_RE = /https?:\/\/ucarecdn\.com\/[^\s"'<>]+/;

    // Arch crop shape — same CSS-illusion approach as circle, matching the
    // aspect ratio + border-radius used in arlo-photo-uploader.js's ARCH_ASPECT/ARCH_RADIUS.
    // MUST stay numerically identical to that file (and to admin/public/index.html's
    // ARCH_ASPECT) — this was previously 41% here vs 40% there, a silent mismatch that
    // made the cart thumbnail's curve very slightly different from the live crop tool's.
    // Correct value = (ARCH_ASPECT / 2) * 100 = 40.5% for ARCH_ASPECT = 0.81.
    var ARCH_RADIUS = '50% 50% 4px 4px / 40.5% 40.5% 4px 4px';

    var styleEl = document.createElement('style');
    styleEl.textContent =
      '.arlo-cp-thumb{display:block;width:100%;margin-top:6px;max-width:240px;border-radius:4px;border:1px solid rgba(0,0,0,.08)}' +
      '.arlo-cp-thumb--circle{width:100px;height:100px;max-width:none;object-fit:cover;border-radius:50%}' +
      '.arlo-cp-thumb--arch{width:100px;height:123px;max-width:none;object-fit:cover;border-radius:' + ARCH_RADIUS + '}' +
      // Grid layout for multi-photo line items — always 4 across
      '.arlo-cp-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:6px;margin-top:6px}' +
      '.arlo-cp-grid .arlo-cp-thumb{margin-top:0;width:100%;height:auto;aspect-ratio:1/1;max-width:none;object-fit:cover;border:1px solid rgba(0,0,0,.08)}' +
      '.arlo-cp-grid .arlo-cp-thumb--circle{border-radius:50%}' +
      '.arlo-cp-grid .arlo-cp-thumb--arch{aspect-ratio:0.81;border-radius:' + ARCH_RADIUS + '}' +
      '.arlo-cp-dup-hidden{display:none !important}';
    document.head.appendChild(styleEl);

    // Map of Uploadcare UUID → crop shape ('circle' | 'arch') for the line item it
    // belongs to. Populated from /cart.js: an item is circle when it has the
    // _arlo_circle="true" property (written by arlo-photo-uploader.js for any
    // circle-crop uploader), OR its product name/handle contains "round" (fallback
    // that also covers the case where the flag doesn't reach the cart). Arch items
    // carry _arlo_shape="arch". Matching per-UUID keeps it precise even when a cart
    // mixes shapes.
    var _shapeUuids = {};
    function uuidOf(u) {
      var m = String(u).match(/ucarecdn\.com\/([a-f0-9\-]+)/i);
      return m ? m[1].toLowerCase() : null;
    }
    function loadCircleData() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          (cart.items || []).forEach(function (item) {
            var props = item.properties || {};
            var name = ((item.product_title || item.title || '') + ' ' + (item.handle || '')).toLowerCase();
            var isArch = String(props._arlo_shape).toLowerCase() === 'arch';
            var isCircle = !isArch && (String(props._arlo_circle).toLowerCase() === 'true' || name.indexOf('round') !== -1);
            if (!isArch && !isCircle) return;
            var shape = isArch ? 'arch' : 'circle';
            // _arlo_shape_uuids scopes the shape to the exact photo UUID(s) written
            // by arlo-photo-uploader.js. WITHOUT this, every ucarecdn.com URL on the
            // line item would get the shape — including an unrelated canvas-png
            // personalised-message PNG on the same product, which should never be
            // shape-cropped. Only fall back to the old "every URL on the item" match
            // when the property is missing (older carts already in progress, or the
            // name-contains-"round" heuristic, which has no specific UUID to scope to).
            if (props._arlo_shape_uuids) {
              String(props._arlo_shape_uuids).split(',').forEach(function (id) {
                id = id.trim().toLowerCase();
                if (id) _shapeUuids[id] = shape;
              });
            } else {
              Object.keys(props).forEach(function (k) {
                var id = uuidOf(props[k]);
                if (id) _shapeUuids[id] = shape;
              });
            }
          });
        })
        .catch(function () {});
    }

    // Some cart apps (confirmed: Unicorn Cart) render each property as a
    // <dt>Photo 1</dt><dd>[url]</dd> pair instead of "Photo 1: [url]" in one text
    // node — so the "before" text on the URL's own text node comes up empty and the
    // "Photo N" marker below never gets set, silently disabling grid grouping.
    // Fallback: walk backward through preceding sibling elements of the node that
    // will hold the URL/image (this reaches the <dt> directly in the dl>div>dt,dd
    // pattern) and use the first one with non-empty text as the label.
    function findPrecedingLabel(textNode) {
      var el = textNode.parentNode && textNode.parentNode.previousElementSibling;
      while (el) {
        var t = (el.textContent || '').replace(/:\s*$/, '').trim();
        if (t) return t;
        el = el.previousElementSibling;
      }
      return '';
    }

    function scanAndReplace() {
      var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
        acceptNode: function(n) {
          // Skip script, style, noscript, our own img already processed
          var tag = n.parentNode && n.parentNode.tagName;
          if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') return NodeFilter.FILTER_REJECT;
          if (n.parentNode && n.parentNode.dataset && n.parentNode.dataset.arloDone) return NodeFilter.FILTER_REJECT;
          return UCARECDN_RE.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      }, false);

      var nodes = [];
      var n;
      while ((n = walker.nextNode())) nodes.push(n);

      nodes.forEach(function(textNode) {
        var match = textNode.nodeValue.match(UCARECDN_RE);
        if (!match) return;
        // Strip any existing Uploadcare transforms to get the base UUID URL
        var rawUrl = match[0];
        var baseMatch = rawUrl.match(/https?:\/\/ucarecdn\.com\/[a-f0-9\-]+(?:~\d+)?\//);
        var url = baseMatch ? baseMatch[0].replace(/\/$/, '') : rawUrl.replace(/\/$/, '');
        var id = uuidOf(url);
        var shape = id && _shapeUuids[id]; // 'circle' | 'arch' | undefined
        // Circle/arch crops get a scale_crop matching their aspect ratio (so the
        // shape isn't stretched); everything else keeps the original aspect-preserving resize.
        // resize/480x (vs the old 120x) gives canvas-png text thumbnails (e.g. a
        // "Personalised Message") a high-res source to stay legible when displayed —
        // .arlo-cp-thumb's CSS max-width caps the actual on-screen size.
        var thumb = shape === 'circle'
          ? url + '/-/scale_crop/240x240/center/-/quality/smart/'
          : shape === 'arch'
          ? url + '/-/scale_crop/200x246/center/-/quality/smart/'
          : url + '/-/resize/480x/-/quality/smart/';
        // "before" = text sitting in the SAME node as the URL (e.g. "Photo 1: [url]"
        // all one text node) — if non-empty, it's re-inserted next to the image below,
        // exactly reproducing what was already there.
        // "labelForMarker" = the best label we can find AT ALL, including a fallback to
        // a separate <dt> sibling (see findPrecedingLabel) for cart apps like Unicorn
        // that render "<dt>Photo 1</dt><dd>[url]</dd>" as two elements. This is used
        // ONLY to test the photo-series marker below — it must NEVER be re-inserted as
        // text, because when it comes from the <dt> fallback that label is already
        // visible on its own; re-inserting it created a genuine duplicate ("Photo 1:
        // Photo 1", "Custom image: Custom image", "Personalised Message: Personalised
        // Message") and broke the row-cleanup regex further down, which in turn caused
        // hideDuplicateLabelRows() to hide the whole row — including the actual image.
        var before = textNode.nodeValue.replace(match[0], '').replace(/:\s*$/, '').trim();
        var labelForMarker = before || findPrecedingLabel(textNode);

        var frag = document.createDocumentFragment();
        if (before) frag.appendChild(document.createTextNode(before));
        var img = document.createElement('img');
        img.src = thumb;
        img.className = shape ? ('arlo-cp-thumb arlo-cp-thumb--' + shape) : 'arlo-cp-thumb';
        img.alt = 'Preview';
        // Only a genuine multi-photo upload property ("Photo 1", "Photo 2", ... — the
        // exact naming arlo-photo-uploader.js uses) should ever be swept into the grid
        // layout below. Without this marker, a lone photo sitting next to an unrelated
        // canvas-png property (e.g. "Personalised Message") gets miscounted as a second
        // "photo" and both get force-merged into a shared grid — squashing the message
        // PNG into a small square alongside the photo instead of rendering it separately.
        if (/^photo\s*\d+$/i.test(labelForMarker)) img.dataset.arloPhotoSeries = '1';
        frag.appendChild(img);

        var parent = textNode.parentNode;
        parent.replaceChild(frag, textNode);
        parent.dataset.arloDone = '1';
      });

      groupIntoGrids();
      hideDuplicateLabelRows();
    }

    // Unicorn Cart (and possibly other cart apps) renders a SECOND summary line for
    // image-type properties below the real thumbnail/grid — where the "value" shown
    // is just the property name repeated back (e.g. "Photo 1: Photo 1", "Custom
    // image: Custom image"), since the real value (a long ucarecdn.com URL) isn't
    // meant to be printed inline there. Once the actual image is showing above, that
    // line is pure redundant clutter. Only touches rows for known image-property
    // names (Photo N / Custom image) — leaves everything else (e.g. a genuine
    // "Personalised Message: <typed text>" row) alone.
    function hideDuplicateLabelRows() {
      var candidates = document.querySelectorAll('dt,dd,li,p,div,span,td,th');
      candidates.forEach(function (el) {
        if (el.dataset.arloDupChecked) return;
        el.dataset.arloDupChecked = '1';
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!t) return;
        var m = t.match(/^(.+?)\s*:\s*\1$/i);
        if (m && /^(photo\s*\d+|custom\s*image)$/i.test(m[1].trim())) {
          el.classList.add('arlo-cp-dup-hidden');
        }
      });
    }

    // For one thumb, the tightest ancestor that holds 2+ (ungridded) thumbs — i.e.
    // that item's photo list. We DON'T assume any wrapper class; groupIntoGrids then
    // keeps only the tightest such containers, so a parent spanning multiple line
    // items is never chosen (which previously merged different products' photos).
    function tightestMultiThumbAncestor(img) {
      var el = img.parentNode;
      while (el && el !== document.body) {
        if (el.querySelectorAll('.arlo-cp-thumb[data-arlo-photo-series]:not(.arlo-cp-gridded)').length >= 2) return el;
        el = el.parentNode;
      }
      return null;
    }

    // A row is safe to delete only if it is clearly just a photo label (e.g. "Photo 1:")
    // — never a product title, price, quantity, or link. Prevents nuking cart items.
    function isPhotoLabelRow(row) {
      if (!row) return false;
      if (row.querySelector('a,button,input,select')) return false;
      if (row.querySelector('img')) return false; // still holds a thumb
      var t = (row.textContent || '').trim();
      if (t.length > 24) return false;
      return t === '' || /^(photo|image|custom image)\s*\d*\s*:?$/i.test(t);
    }

    function groupIntoGrids() {
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('.arlo-cp-thumb:not(.arlo-cp-gridded)'));
      var candidates = [];
      thumbs.forEach(function (img) {
        var c = tightestMultiThumbAncestor(img);
        if (c && candidates.indexOf(c) === -1) candidates.push(c);
      });

      // Keep only the TIGHTEST containers: drop any candidate that contains another
      // candidate. This guarantees we never pick a parent that spans multiple line
      // items (which would merge different products' photos into one grid).
      var containers = candidates.filter(function (c) {
        return !candidates.some(function (o) { return o !== c && c.contains(o); });
      });

      containers.forEach(function (container) {
        if (container.querySelector(':scope > .arlo-cp-grid')) return;
        // Only actual "Photo N" series thumbs go in the grid — an unrelated canvas-png
        // property (e.g. "Personalised Message") sharing this container must never be
        // swept in even if it happens to sit alongside 2+ real photos.
        var imgs = Array.prototype.slice.call(container.querySelectorAll('.arlo-cp-thumb[data-arlo-photo-series]'));
        if (imgs.length < 2) return;

        // Find the container's direct child that holds the first thumb — anchor the grid there.
        var anchor = imgs[0];
        while (anchor.parentNode && anchor.parentNode !== container) anchor = anchor.parentNode;

        var grid = document.createElement('div');
        grid.className = 'arlo-cp-grid';
        container.insertBefore(grid, anchor);

        imgs.forEach(function (img) {
          // Row = the container's direct child that this thumb lives in (the "Photo N:" line).
          var row = img;
          while (row.parentNode && row.parentNode !== container) row = row.parentNode;
          img.classList.add('arlo-cp-gridded');
          grid.appendChild(img);
          // Only remove the leftover row if it's clearly just a photo label — never
          // a title/price/quantity row.
          if (row && row.parentNode === container && isPhotoLabelRow(row)) {
            container.removeChild(row);
          }
        });
      });
    }

    function refresh() { loadCircleData().then(scanAndReplace); }

    document.addEventListener('DOMContentLoaded', refresh);

    // Re-run on any DOM change (catches Unicorn + any other AJAX cart). Reload the
    // circle data too, since the cart contents may have changed (item added/removed).
    var timer;
    var observer = new MutationObserver(function() {
      clearTimeout(timer);
      timer = setTimeout(refresh, 150);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();
  // ── End Arlo cart property enhancer ─────────────────────────────────────────

  // ── Hide app-injected "Savings" line in the cart ────────────────────────────
  // The savings summary row is added by a third-party app (not the theme), so we
  // remove it in JS. Scoped to cart containers so real "Savings" text elsewhere is
  // left alone. Uses a MutationObserver because the app injects the row late.
  (function arloHideCartSavings() {
    function hideSavings() {
      var scopes = document.querySelectorAll('.cart, .quick-cart, [data-section-type="quick-cart"], form[action*="/cart"]');
      for (var s = 0; s < scopes.length; s++) {
        var els = scopes[s].querySelectorAll('*');
        for (var i = 0; i < els.length; i++) {
          var el = els[i];
          if (el.children.length === 0 && /^\s*savings\s*$/i.test(el.textContent || '')) {
            var row = el, done = false;
            for (var k = 0; k < 4 && row; k++) {
              if (row !== el && /saving/i.test(row.textContent) && /[$£€]/.test(row.textContent)) {
                row.style.display = 'none'; done = true; break;
              }
              row = row.parentNode;
            }
            if (!done && el.parentNode) el.parentNode.style.display = 'none';
          }
        }
      }
    }
    hideSavings();
    document.addEventListener('DOMContentLoaded', hideSavings);
    var t;
    var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(hideSavings, 120); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  })();

  // ── "Others Also Bought" cards ──────────────────────────────────────────────
  // Rendered from this asset (not the cached quick-cart section) so it updates
  // live. Takes over the #arlo-recs container the section outputs: reads its data
  // attributes, fetches recommendations, and renders 2-up scrolling cards with
  // NEW / % OFF badges, colour swatches, sale price and an Add-to-cart button.
  (function arloCartRecs() {
    var STYLE_ID = 'arlo-recs-v2-style';
    function injectStyle() {
      if (document.getElementById(STYLE_ID)) return;
      var s = document.createElement('style');
      s.id = STYLE_ID;
      s.textContent = [
        '#arlo-recs .xs-heading{font-weight:600;font-size:14px;margin:12px 0 10px}',
        '#arlo-recs .xs-scroller{display:flex;gap:12px;overflow-x:auto;scroll-snap-type:x proximity;-webkit-overflow-scrolling:touch;padding-bottom:8px}',
        '#arlo-recs .xs-scroller::-webkit-scrollbar{height:6px}',
        '#arlo-recs .xs-scroller::-webkit-scrollbar-thumb{background:rgba(0,0,0,.18);border-radius:3px}',
        '#arlo-recs .xs-card{flex:0 0 47%;scroll-snap-align:start;display:flex;flex-direction:column}',
        '#arlo-recs .xs-imgwrap{position:relative;display:block;border-radius:8px;overflow:hidden;background:#f4f4f4}',
        '#arlo-recs .xs-img{width:100%;aspect-ratio:1/1;object-fit:cover;display:block}',
        '#arlo-recs .xs-badges{position:absolute;top:8px;left:8px;display:flex;flex-direction:column;gap:4px}',
        '#arlo-recs .xs-badge{font-size:11px;font-weight:700;color:#fff;padding:3px 8px;border-radius:14px;background:var(--color-button-primary-background,#2b5563)}',
        '#arlo-recs .xs-swatches{display:flex;gap:5px;margin:8px 0 4px}',
        '#arlo-recs .xs-swatch{width:14px;height:14px;border-radius:50%;border:1px solid rgba(0,0,0,.15)}',
        '#arlo-recs .xs-title{font-size:13px;line-height:1.3;color:inherit;text-decoration:none;display:block;margin-bottom:4px}',
        '#arlo-recs .xs-pricerow{font-size:13px;margin-bottom:8px}',
        '#arlo-recs .xs-price{font-weight:600}',
        '#arlo-recs .xs-compare{text-decoration:line-through;opacity:.6;margin-left:2px}',
        '#arlo-recs .xs-sale{color:var(--color-button-primary-background,#2b5563);margin-left:2px}',
        '#arlo-recs .xs-add{margin-top:auto;width:100%;padding:8px;border:none;border-radius:6px;cursor:pointer;font-weight:700;font-size:12px;background:var(--color-button-primary-background,#2b5563);color:var(--color-button-primary-text,#fff)}'
      ].join('');
      document.head.appendChild(s);
    }

    var PROT_IDS = [8053514436790, 8082449137846];
    var PROT_HANDLES = ['shipping-protection','shipping-insurance','order-armor','navidium-shipping-protection'];
    function money(c) { return '$' + (c / 100).toFixed(2); }
    function colorHex(name) {
      var m = { purple:'#7e57c2', lilac:'#b39ddb', navy:'#1b2a4a', black:'#111', white:'#fff', blue:'#3f6fb0', red:'#c0392b', green:'#3a8f5a', mint:'#8fd3b6', pink:'#e59bb5', grey:'#9aa0a6', gray:'#9aa0a6', yellow:'#e6c34a', orange:'#e07b39', teal:'#2b8a8a', brown:'#8a5a3a', beige:'#e3d4bb', cream:'#f2ead5', silver:'#c8ccd0', gold:'#c9a24b', tan:'#d2b48c' };
      var k = String(name || '').toLowerCase();
      for (var key in m) { if (k.indexOf(key) !== -1) return m[key]; }
      return '#cfcfcf';
    }
    function swatches(p) {
      var opt = (p.options || []).filter(function (o) { return /colou?r/i.test(o.name); })[0];
      if (!opt || !opt.values || !opt.values.length) return '';
      return '<div class="xs-swatches">' + opt.values.slice(0, 6).map(function (v) {
        return '<span class="xs-swatch" style="background:' + colorHex(v) + '"></span>';
      }).join('') + '</div>';
    }

    function render(el, products, heading, cartIds) {
      var list = products.filter(function (p) {
        var isP = PROT_IDS.indexOf(p.id) !== -1 || PROT_HANDLES.indexOf(p.handle) !== -1 || (p.title || '').toLowerCase().indexOf('parcel') !== -1;
        return cartIds.indexOf(p.id) === -1 && p.available && !isP;
      }).slice(0, 10);
      if (!list.length) { el.style.display = 'none'; return; }
      var cards = list.map(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0] || {};
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') >= 0 ? '&' : '?') + 'width=400' : '';
        var isNew = (p.tags || []).some(function (t) { return String(t).toLowerCase() === 'new'; });
        var cmp = v.compare_at_price || 0, onSale = cmp && cmp > v.price, pct = onSale ? Math.round((1 - v.price / cmp) * 100) : 0;
        var b = ''; if (isNew) b += '<span class="xs-badge">NEW</span>'; if (onSale) b += '<span class="xs-badge">' + pct + '% OFF</span>';
        var pr = onSale
          ? '<span class="xs-price">' + money(v.price) + '</span> <span class="xs-compare">' + money(cmp) + '</span> <span class="xs-sale">Sale</span>'
          : '<span class="xs-price">' + money(v.price) + '</span>';
        return '<div class="xs-card"><a class="xs-imgwrap" href="' + p.url + '">'
          + (b ? '<div class="xs-badges">' + b + '</div>' : '')
          + (img ? '<img class="xs-img" src="' + img + '" alt="" loading="lazy">' : '')
          + '</a>' + swatches(p)
          + '<a class="xs-title" href="' + p.url + '">' + p.title + '</a>'
          + '<div class="xs-pricerow">' + pr + '</div>'
          + '<button type="button" class="xs-add" data-vid="' + (v.id || '') + '">Add to cart</button></div>';
      }).join('');
      el.innerHTML = '<div class="xs-wrap"><div class="xs-heading">' + heading + '</div><div class="xs-scroller">' + cards + '</div></div>';
      el.style.display = '';
      el.setAttribute('data-arlo-v2', '1');
      el.querySelectorAll('.xs-add').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var vid = btn.getAttribute('data-vid'); if (!vid) return;
          btn.disabled = true; btn.textContent = 'Adding…';
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 }) })
            .then(function () { if (window.emit) { window.emit('quick-cart:updated'); window.emit('quick-cart:open'); } document.dispatchEvent(new CustomEvent('cart:item-added')); btn.textContent = 'Added ✓'; })
            .catch(function () { btn.disabled = false; btn.textContent = 'Add to cart'; });
        });
      });
    }

    var _busy = false;
    function build() {
      var el = document.getElementById('arlo-recs');
      if (!el) return;
      if (el.getAttribute('data-arlo-v2') === '1' && el.querySelector('.xs-wrap')) return; // already ours
      var primaryId = el.dataset.recProductId; if (!primaryId) return;
      var cartIds = (el.dataset.cartProductIds || '').split(',').filter(Boolean).map(Number);
      var heading = el.dataset.heading || 'Others Also Bought';
      if (_busy) return; _busy = true;
      injectStyle();
      var overrides = window.arloCrossSellOverrides || [];
      var p = overrides.length
        ? Promise.all(overrides.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).catch(function () { return null; }); })).then(function (rs) { return { products: rs.filter(Boolean) }; })
        : fetch('/recommendations/products.json?product_id=' + primaryId + '&intent=related&limit=10').then(function (r) { return r.json(); });
      p.then(function (data) { render(el, (data && data.products) || [], heading, cartIds); })
        .catch(function () {})
        .then(function () { _busy = false; });
    }

    document.addEventListener('DOMContentLoaded', build);
    document.addEventListener('cart:item-added', function () { setTimeout(build, 900); });
    var rt;
    var rmo = new MutationObserver(function () { clearTimeout(rt); rt = setTimeout(build, 200); });
    rmo.observe(document.documentElement, { childList: true, subtree: true });
    build();
  })();

  // Set cookie
  function setCookieJS(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  // Get cookie
  function getCookieJS(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
